import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import { DateTime } from 'components/Erp/Display';
import React from 'react'
import { UserRound, Search, ChevronLeft, ChevronRight } from 'lucide-react'
import s from './PanelBase.module.scss'
import { SectionHeading, EmptyState } from 'components/Erp/Presentation'

const ReadOnlyOperatorsList = ({
  base,
  operators = [],
  operatorsFilter = '',
  setOperatorsFilter = () => {},
  loadOperatorsPage = () => {},
  operatorsPagination = {},
  title = tr("Операторы"),
}) => {
  useInterfaceLanguage();
  const filtered = operators.filter(op => {
    const q = (operatorsFilter || '').toLowerCase()
    if (!q) return true
    const emp = op.employee_name || String(op.employee)
    return (emp && emp.toLowerCase().includes(q)) || (op.phone && String(op.phone).toLowerCase().includes(q))
  })

  return (
    <div className={s.subPanel}>
      <SectionHeading icon={UserRound} title={tr(title)} as="h3" />

      <div className={s.searchRow}>
        <Search size={16} aria-hidden="true" />
        <input
          className={s.searchInput}
          placeholder={tr("Поиск по оператору...")}
          value={operatorsFilter || ''}
          onChange={(e) => setOperatorsFilter(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') loadOperatorsPage(base.id, 1, operatorsFilter || '') }}
        />
      </div>

      {filtered.length ? (
        <>
          <div className={s.tableWrap}>
            <div className={s.tableScroll}>
            <table className={s.table}>
              <thead>
                <tr>
                  <th>№</th>
                  <th>{tr("Сотрудник")}</th>
                  <th>{tr("Телефон")}</th>
                  <th>{tr("Доп. тел.")}</th>
                  <th>{tr("Создано")}</th>
                  <th>{tr("Статус")}</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((op, index) => (
                  <tr key={op.id}>
                    <td data-label={tr("№")} className={s.numCell}>{tr(index + 1)}</td>
                    <td data-label={tr("Сотрудник")} style={{ fontWeight: 600, color: "var(--theme-text, #1e293b)" }}>{tr(op.employee_name || op.employee)}</td>
                    <td data-label={tr("Телефон")}>{tr(op.employee_phone || '—')}</td>
                    <td data-label={tr("Доп. тел.")}>{tr(op.phone || '—')}</td>
                    <td data-label={tr("Создано")} style={{ fontSize: 12, color: "var(--theme-text-muted, #64748b)" }}><DateTime value={op.created_at} /></td>
                    <td data-label={tr("Статус")}>
                      <span className={`${s.badge} ${op.is_active ? s.active : s.inactive}`}>
                        {op.is_active ? tr("Активен") : tr("Неактивен")}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </div>

          {tr(!operatorsFilter && operatorsPagination?.count > 0 && (
            <div className={s.pagination}>
              <button className={s.pageBtn} disabled={!operatorsPagination.previous} onClick={() => loadOperatorsPage(base.id, (operatorsPagination.page || 1) - 1)}><ChevronLeft size={15} aria-hidden="true" />{tr("Пред.")}</button>
              <span>{tr("Стр. ")}{tr(operatorsPagination.page || 1)}{tr(" из ")}{Math.ceil(operatorsPagination.count / 25)}</span>
              <button className={s.pageBtn} disabled={!operatorsPagination.next} onClick={() => loadOperatorsPage(base.id, (operatorsPagination.page || 1) + 1)}>{tr("След.")}<ChevronRight size={15} aria-hidden="true" /></button>
            </div>
          ))}
        </>
      ) : (
        <EmptyState icon={UserRound} title={tr("Операторы не найдены")} description={tr("Измените поисковый запрос или выберите другой объект.")} compact />
      )}
    </div>
  )
}

export default ReadOnlyOperatorsList
